import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pw822fx5pb: FaireBrandEntity = {
  token: "b_pw822fx5pb",
  type: "brand",
  name: "Lili Scarves (USA Duties Paid)",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c9be15e69dee8e7c9d55f60329f2cf017e8cd6ccc6aeb86d0656c6fcd7c84f0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/33a80bdc36012a3e21ae11114e9bbd5af7d2bb474360009176d39ad694a1312c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3c9be15e69dee8e7c9d55f60329f2cf017e8cd6ccc6aeb86d0656c6fcd7c84f0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/33a80bdc36012a3e21ae11114e9bbd5af7d2bb474360009176d39ad694a1312c.png",
  location: "GBR",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 129,
  isTopShop: true,
  isInsider: false,
  description:
    "Lili Scarves is a wholesale supplier born in 2008 and its headquarters is based in London, United Kingdom. Our vision is to provide high-quality scarves at a competitive price with fast delivery. Our wide range of products consist of over 1000+ items and it ranges from winter wool scarves to basic cotton. We have something for everyone. \n\nOur promise to you is next-day delivery within the UK and international orders will be shipped out the same day when the orders are placed before 12pm. If you have any questions our customer service team is here to help and we will get back to you within 12 hours. Whether you have a physical or an online store, we are committed to offering you the best possible service! \n\nFrom our heart to yours, thank you for supporting Lili Scarves!\n\n\nNote: We offer duty-free shipping services to the USA. Estimated shipping is usually higher. For an accurate shipping cost, please contact us before ordering.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:50.237Z",
    importedBy: "entity-db-cli",
  },
};
